import { css, styled } from 'styled-components';

export const Container = styled.div<{ hideBorder: boolean }>`
  width: 100%;
  height: 3.625rem;
  padding: 0 0.8rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;

  ${({ hideBorder }) =>
    hideBorder &&
    css`
      border: none;
    `}

  > div {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
`;
